//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ButtonToggle from '@/components/d0822/fields/buttonToggle.vue';
import filterMixin from '@/mixins/filter';

export default {
  components: { ButtonToggle },
  mixins: [filterMixin],
  props: {
    namespace: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      toggleFilter: null,
      fields: [
        {
          name: 'courses',
          clearable: true,
          urlQuery: true,
          urlValueGetter: 'courses/GET_DIRECTION_SLUG_FROM_ID',
          serverValueGetter: 'courses/GET_DIRECTION_ID_FROM_SLUG',
          alias: 'directions',
          nullState: '0',
          toArray: true,
          unique: true,
        },
        { name: 'textSearch', clearable: false, urlQuery: true },
        {
          name: 'types',
          clearable: true,
          urlQuery: true,
          urlValueGetter: 'courses/GET_TYPE_SLUG_BY_ID',
          serverValueGetter: 'courses/GET_TYPE_ID_BY_SLUG',
          toArray: true,
          unique: true,
        },
        {
          name: 'jobGuarantee',
          urlQuery: true,
          clearable: true,
          boolean: true,
          unique: true,
        },
        // {
        //   name: 'bundle',
        //   urlQuery: true,
        //   clearable: true,
        //   boolean: true,
        //   unique: true,
        // },

        {
          name: 'page',
          urlQuery: true,
          clearable: false,
        },
      ],
    };
  },
  fetch() {
    this.fillToggleFilter();
  },
  computed: {
    // Filter fields
    textSearch: {
      get() {
        return this.filter.textSearch;
      },
      set(payload) {
        return this.filterFieldUpdate('textSearch', payload);
      },
    },
  },
  created() {
    this.createFilterOnFirstFetch();
  },
  methods: {
    // Events
    onInput(payload) {
      if (payload === 'courses.0') {
        this.clear();
        return;
      }

      const splitted = payload.split('.');
      let param = splitted[0];
      let value = splitted[1];

      this.filterFreeze = { payload: true };
      this.clear();
      this.filterFieldUpdate(param, value);
      this.filterFreeze = { payload: false, ignore: false };
    },
    /** Fill filter value on first page load */
    fillToggleFilter() {
      let result = 'courses.0';

      const filter = this.parsedFilter;
      const keys = Object.keys(filter);
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const field = this.fields.find((i) => [i.name, i.alias].includes(key));
        if (!field) continue;
        if (field.unique) {
          result = `${field.name}.${filter[key]}`;
        }
      }

      this.toggleFilter = result;
    },
    /** Create filter instance in mixin */
    createFilterOnFirstFetch() {
      if (!this.filter) {
        let fields = this.fields;
        this.createFilter(this.filterNamespace, fields);
      }
    },
  },
};
